import * as React from 'react';
import { Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, FormGroup, Checkbox, InputLabel, Select, MenuItem } from '@material-ui/core';
import { TheInitialInterviewSuggestionType, GroupCoachingLevelPrice, GroupCoachingLevelName, GroupCoachingType, OneOnOneCoachingType } from '../constants';
import { useQuery } from 'react-query';
import { CoachCampAPI, getCourseCollection } from '../utils/api';
import Cascader from './Cascader';
import { compareVersion, support107 } from '../utils';

const behavior = [
    '攻击性行为', '做出残忍行为', '好争辩', '急躁', '有自杀想法',
    '情绪忽高忽低', '情绪失控', '易怒', '焦虑', '恐慌', '担心', '害怕',
    '抑郁心境', '行为退缩', '一个想法反复纠缠', '不喜欢表达出想法', '害羞', '易疲乏',
    '分心', '经常生病', '沉迷网络', '孤独', '不想见人',
    '容易和父母发生冲突', '容易和兄弟姐妹发生冲突', '容易和老师发生冲突', '容易和同学朋友发生冲突', '不太会沟通', '容易误解他',
]
const childProblem = [
    '孩子被诊断（怀疑）为ADHD',
    '孩子行为问题',
    '孩子学习障碍问题',
    '孩子的情绪和精神健康问题',
    '学校适应的问题',
    '同伴相处等社交问题',
]
const selfProblem = [
    '被诊断（怀疑）为ADHD',
    '工作适应问题',
    '情绪和精神健康问题',
    '家庭关系问题',
    '婚姻问题',
    '如何调整家庭的变故，包括疾病、死亡、离异和搬迁等等',
]
const grade = [
    '学前', '小学低年级', '小学高年级', '初中', '高中', '本科', '本科以上'
]
const course = [
    ['数学', '蒙氏', '写字', '阅读', '手工', '外语', '美术', '体育', '表演/舞蹈', '音乐'],
    ['数学', '语文', '品德/生活/社会', '外语', '科学', '艺术', '体育/健康', '信息技术', '社会实践/劳动'],
    ['数学', '语文', '品德/生活/社会', '外语', '科学', '艺术', '体育/健康', '信息技术', '社会实践/劳动'],
    ['数学', '语文', '品德/生活/社会', '外语', '体育', '美术', '音乐', '历史', '地理', '物理', '生物', '化学', '信息技术', '其它'],
    ['数学', '语文', '外语', '思想政治', '历史', '地理', '生物', '物理', '化学', '信息技术', '通用技术', '音乐', '美术', '体育与健康', '其它'],
    ['专业课', '数学', '外语', '政治', '哲学', '心理学', '法律', '物理', '计算机/互联网', 'AI/大数据', '美学', '体育', '其它'],
    ['专业课', '数学', '政治', '哲学', '心理学', '法律', '物理', '计算机', '美学', '体育', '其它']
]
const performance = [
    '优秀', '优良', '中等', '中下', '较低'
]
const job = [
    '各类技术人员（工程/生物/科研/计算机/设计等）',
    '各类专业人士（医生/律师/咨询师/会计师等）',
    '教师/教育行业工作者',
    '军人/武警/公检法工作者',
    '艺术/娱乐/演艺工作者',
    '商业/服务业工作者',
    '国家机关/党群组织/事业单位的负责人',
    '国家机关/党群组织/事业单位的公务员',
    '企业高管/负责人',
    '公司职员/单位办事员',
    '农林牧渔劳动者',
    '自由职业',
    '待业'
]

const hobbies = [
    '旅游/徒步/露营',
    '自驾',
    '电影/电视剧',
    '读书',
    '跑步',
    '游泳',
    '足球/篮球/排球',
    '乒乓球/羽毛球/网球',
    '高尔夫/马术',
    '音乐/乐器/舞蹈',
    '刷手机',
    '聊天',
    '冥想/瑜伽',
    '绘画',
    '手游/网游',
    '自行车'
]

const playTime = [
    '超过每天4小时',
    '每天2-4小时',
    '每天1-2小时',
    '平均每天少于1小时'
]
export type DataProps = {
    input: { [key: string]: string },
    radio: { [key: string]: string },
    checkbox: { [key: string]: { [index: string]: boolean } },
    familyMember: { relationship: string, age: string }[],
    suggestion: { [key: string]: TheInitialInterviewSuggestion | undefined }
}
type CoachingQuestionnaireSurveyProps = {
    data: DataProps,
    courses: Course[],
    coaches: Coach[],
    onDataChange?: (data: DataProps) => void,
    isVip: boolean,
    writer: { user_id: number, name: string },
    version?: string,
}

const CoachingQuestionnaireSurvey = ({ data, courses, isVip, coaches, writer, onDataChange,version }: CoachingQuestionnaireSurveyProps) => {

    const { data: camps } = useQuery(['listcoachcampforcoach'], () => CoachCampAPI.listForCoach())
    const { data: collections } = useQuery(['listcoursecollections'], () => getCourseCollection())
    let state = data.input;
    let radioState = data.radio;
    let checkBoxState = data.checkbox;
    let familyMember = data.familyMember;
    let suggestion = data.suggestion;

    const handleStateChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value
        let members = [...familyMember]
        if (key === 'familyMemberCount' && !isNaN(+value) && value != '') {

            if (familyMember.length < +value) {
                for (let i = 0; i < +value - familyMember.length; i++) {
                    members.push({ age: '', relationship: '' })
                }
            } else {
                members = familyMember.slice(0, +value)
            }
        }
        onDataChange && onDataChange({
            input: { ...state, [key]: value },
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: members,
            suggestion
        })

    }
    const handleInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        onDataChange && onDataChange({
            input: state,
            radio: { ...radioState, [key]: event.target.value },
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }
    const handCheckBoxChange = (key: string, index: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (checkBoxState[key]) {
            checkBoxState[key][index] = event.target.checked
        } else {
            checkBoxState[key] = { [index]: event.target.checked }
        }
        checkBoxState[key][index] = event.target.checked
        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: { ...checkBoxState },
            familyMember: familyMember,
            suggestion
        })
    }
    const handleFamilyChange = (index: number, key: 'relationship' | 'age') => (event: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => {
        familyMember[index][key] = event.target.value as string
        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: [...familyMember],
            suggestion
        })
    }

    const handleSuggestionCheckChange = (type: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            suggestion[type] = { type: '' }
        } else {
            delete suggestion[type]
        }

        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }


    const fee = (type: string, numberOfTimes: string = '0', coachId?: string, groupCoachingLevel?: string) => {

        const [coach] = coaches.filter(coach => coachId === `${coach.user_id}`)
        if (type === TheInitialInterviewSuggestionType.one_on_one_coaching) {
            return coach ? coach.price * +numberOfTimes : 0
        } else if (type === TheInitialInterviewSuggestionType.group_coaching) {
            return groupCoachingLevel ? GroupCoachingLevelPrice[groupCoachingLevel] : 0
        }
        return 0;
    }


    const handleSuggestionChange = (type: string, key: 'numberOfTimes' | 'coachId' | 'material' | 'content' | 'groupCoachingLevel' | 'isDiscount6' | 'type') => (event: React.ChangeEvent<HTMLInputElement>) => {
        const s = suggestion[type]
        if (s) {
            if (key === 'isDiscount6') {
                s[key] = event.target.checked ? 1 : 0
            } else {
                s[key] = event.target.value
            }
            if (key === 'numberOfTimes') {
                const original_fee = +event.target.value * 1350
                s['fee'] = `${fee(type, event.target.value, s['coachId'])}`
            }
            if (key === 'groupCoachingLevel') {
                s['fee'] = `${fee(type, '0', s['coachId'], event.target.value)}`
                s['groupCoachingLevelName'] = GroupCoachingLevelName[event.target.value]
            }
            if (key === 'coachId') {
                s['fee'] = `${fee(type, s['numberOfTimes'], event.target.value, s['groupCoachingLevel'])}`
                const [coach] = coaches.filter(coach => event.target.value === `${coach.user_id}`)
                if (coach) {
                    s['coachName'] = coach.name
                } else {
                    
                    s['coachName'] = ''
                }
            }
            suggestion = { ...suggestion, [type]: s }
        }

        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }

    const radioInput = (key: string, label: string, options: string[], row: boolean = true) => {
        return <Box mt={2}>
            <FormControl>
                <FormLabel>
                    {label}
                </FormLabel>
                <RadioGroup row name={key} value={radioState[key] ? radioState[key] : ''} onChange={handleInputChange(key)}>
                    {
                        options.map((value, index) => <FormControlLabel key={`${index}${value}`} value={`${index}`} label={value} control={<Radio size="small" color="secondary" />} />)
                    }
                </RadioGroup>
            </FormControl>
        </Box>
    }

    const checkBoxInput = (key: string, label: string, options: string[], row: boolean = true, hasOther = false) => {
        return <Box mt={2}>
            <FormControl component="fieldset">
                <FormLabel component="legend">{label}</FormLabel>
                <FormGroup row={row}>
                    {
                        options.map((value, index) => <FormControlLabel
                            key={`${index}${value}`}
                            control={<Checkbox size="small" checked={checkBoxState[key] ? !!checkBoxState[key][`${index}`] : false} onChange={handCheckBoxChange(key, `${index}`)} />}
                            label={value}
                        />)
                    }
                    {
                        hasOther && <Box display="flex" alignItems="center">
                            <FormControlLabel
                                control={<Checkbox size="small" checked={checkBoxState[key] ? !!checkBoxState[key][`${options.length + 1}`] : false} onChange={handCheckBoxChange(key, `${options.length + 1}`)} />}
                                label="其他（请描述）"
                            />
                            <TextField value={state[`${key}Other`] ? state[`${key}Other`] : ''} onChange={handleStateChange(`${key}Other`)} />
                        </Box>
                    }
                </FormGroup>
            </FormControl>
        </Box>
    }

    const studentInput = () => {
        return <React.Fragment>
            {radioInput('grade', '年级', grade)}
            {radioState['grade'] && checkBoxInput('likedCourse', '喜欢的科目', course[+radioState['grade']])}
            {radioState['grade'] && checkBoxInput('notLikedCourse', '不喜欢的科目', course[+radioState['grade']])}
            {radioInput('performance', '学习成绩', performance)}
            {radioInput('performanceChange', '最近半年学习成绩是否有明显变化', ['是', '否'])}
            {radioInput('behaviorChange', '最近半年行为情绪是否有明显变化', ['是', '否'])}
        </React.Fragment>
    }

    const notStudentInput = () => {
        return <React.Fragment>
            {radioInput('job', '目前职业', job)}
            {radioInput('workYears', '在目前工作单位的年限', ['1年以内', '1-2年', '2-3年', '3-5年', '5年以上'])}
            {radioInput('workCount', '曾经在几个单位工作过', ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10个以上'])}
            {radioInput('workStateChange', '最近半年工作状态是否有明显变化', ['是', '否'])}
            {radioInput('workBehaviorChange', '最近半年行为情绪是否有明显变化', ['是', '否'])}
        </React.Fragment>
    }

    const handleCoursesChanged = (event: React.ChangeEvent<{ value: unknown }>) => {

        let s = suggestion[TheInitialInterviewSuggestionType.free_course]
        const value = event.target.value as string[]
        if (s) {
            s['courseId'] = value
            let cs: Course[] = []
            courses.map(c => {
                if (value.includes(c.id)) {
                    cs.push({ id: c.id, name: c.name, cover: c.cover })
                }
            })
            s['courses'] = cs
        }
        suggestion = { ...suggestion, [TheInitialInterviewSuggestionType.free_course]: s }
        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }

    const handleCoachCampChanged = (event: React.ChangeEvent<{ value: unknown }>) => {
        let s = suggestion[TheInitialInterviewSuggestionType.coach_camp]
        const value = event?.target.value as string[]
        if (s) {
            s['coachCampIds'] = value
            s['coachCamps'] = camps?.filter(c => value.includes(`${c.id}`)).map(c => ({ id: c.id, name: c.name, cover: c.cover }))
        }
        suggestion = { ...suggestion, [TheInitialInterviewSuggestionType.coach_camp]: s }
        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }

    const handleCourseChanged = (event?: React.ChangeEvent, value?: { [key: string]: string[] }) => {
        let s = suggestion[TheInitialInterviewSuggestionType.free_course]

        if (s && value) {
            s['cascaderValue'] = value
            const _courses = []
            const _newCourses = []
            for (const collectionId of Object.keys(value)) {
                const childrens = value[collectionId]
                console.info(childrens)
                const [collection] = courseCascadeOptions.filter(c => {
                    console.info(`${c.value} ${collectionId} ${c.value === collectionId}`)
                    return c.value === collectionId
                })
                if (collection && childrens.length === collection.children.length) {
                    _newCourses.push({ id: collection.value, name: collection.label, cover: collection.cover, type: 'collection' })
                    _courses.push(...collection.children.map(c => ({ id: c.value, name: c.label, cover: c.cover })))
                } else {
                    _newCourses.push(...collection.children.filter(c => childrens.includes(c.value)).map(c => ({ id: c.value, name: c.label, cover: c.cover, type: 'course' })))
                    _courses.push(...collection.children.filter(c => childrens.includes(c.value)).map(c => ({ id: c.value, name: c.label, cover: c.cover })))
                }
            }
            s['courses'] = _courses
            s['newCourses'] = _newCourses
        }
        suggestion = { ...suggestion, [TheInitialInterviewSuggestionType.free_course]: s }
        onDataChange && onDataChange({
            input: state,
            radio: radioState,
            checkbox: checkBoxState,
            familyMember: familyMember,
            suggestion
        })
    }

    const courseCascadeOptions = React.useMemo(() => {
        const options = []
        if (collections) {
            for (const collection of collections) {
                const children = courses.filter(c => c.collection_id == +collection.id).map(c => ({ label: c.name, value: `${c.id}`, cover: c.cover }))
                options.push({
                    label: collection.name,
                    value: `${collection.id}`,
                    cover: collection.cover,
                    children
                })
            }
        }
        return options
    }, [courses, collections])

    const suggestionCoachCamp = React.useMemo(() => {
        return suggestion[TheInitialInterviewSuggestionType.coach_camp]
    }, [suggestion])

    return <Box>
        <Typography align="center" variant="h5" >首次约谈来访者信息收集</Typography>
        <Box mt={8}>
            <Typography>来访者信息的收集，以便教练更好地做出有针对性的下一步建议和服务方案。</Typography>
            <br />
            <Typography>所有这些信息，除了您和相关工作人员，需要保密。</Typography>
        </Box>

        <Box mt={8}>
            <Box >
                <Typography align="center" variant="h6">寻求首次约谈服务的主要原因</Typography>
            </Box>
            {radioInput('childProblem', '选择1', ['孩子问题', '本人问题'])}
            {radioState['childProblem'] === '0' && checkBoxInput('childProblem', '', childProblem, false, true)}
            {radioState['childProblem'] === '1' && checkBoxInput('selfProblem', '', selfProblem, false, true)}
            {radioInput('problemTime', '这些问题持续多长时间？', ['3个月以内', '半年以内', '1年以内', '1年以上'])}
            {radioInput('affect', '这些问题有多大程度影响每天的生活？', ['有时影响', '经常影响', '持续影响'])}
            <TextField value={state['supplement1'] ? state['supplement1'] : ''} onChange={handleStateChange('supplement1')} fullWidth multiline rows={5} label="需要补充信息" />
        </Box>

        <Box mt={8}>
            <Typography align="center" variant="h6">来访者信息</Typography>
            <Box mt={2}>
                <Typography style={{ fontWeight: 500 }}>基本信息</Typography>
                <Box mt={1}>
                    <TextField label="姓名" style={{ width: '120px', marginRight: '24px' }} value={state['name'] ? state['name'] : ''} onChange={handleStateChange('name')} />
                    <TextField label="年龄" style={{ width: '120px', marginRight: '24px' }} value={state['age'] ? state['age'] : ''} onChange={handleStateChange('age')} />
                    <TextField select label="性别" style={{ width: '120px', marginRight: '24px' }} value={state['gender'] ? state['gender'] : ''} onChange={handleStateChange('gender')}>
                        <MenuItem value="男">男</MenuItem>
                        <MenuItem value="女">女</MenuItem>
                    </TextField>
                </Box>
                {radioInput('maritalStatus', '个人婚姻状况', ['单身', '已婚', '已婚分居', '离异'])}
                <Box mt={1} display="flex" alignItems="center">
                    居住在一起的家庭成员人数<TextField value={state['familyMemberCount'] ? state['familyMemberCount'] : ''} onChange={handleStateChange('familyMemberCount')} style={{ display: 'inline', width: '80px' }} type="number" inputProps={{ style: { textAlign: 'center' }, maxLength: 1 }} />
                </Box>
                <Box>
                    {familyMember.map((member, index) => <Box key={`familyMember${index}`}>
                        <FormControl style={{ width: '80px', marginRight: '20px' }}>
                            <InputLabel>关系</InputLabel>
                            <Select onChange={handleFamilyChange(index, 'relationship')} value={member.relationship}>
                                <MenuItem value="儿子">儿子</MenuItem>
                                <MenuItem value="女儿">女儿</MenuItem>
                                <MenuItem value="父亲">父亲</MenuItem>
                                <MenuItem value="母亲">母亲</MenuItem>
                                <MenuItem value="爷爷">爷爷</MenuItem>
                                <MenuItem value="奶奶">奶奶</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField label="年龄" style={{ width: '80px' }} value={member.age} onChange={handleFamilyChange(index, 'age')} />
                    </Box>)}
                </Box>
            </Box>
            <Box mt={4}>
                <Typography style={{ fontWeight: 500 }}>学习/工作/社交</Typography>
                {radioInput('isStudent', '来访者寻求帮助针对是孩子或者本人是否是学生？', ['是', '不是'])}
                {radioState['isStudent'] === '0' && studentInput()}
                {radioState['isStudent'] === '1' && notStudentInput()}
                {checkBoxInput('hobbies', '兴趣、爱好或者体育运动', hobbies)}
                {radioInput('playTime', '花在看电视，玩手机，玩电子游戏或者在电脑上的娱乐（不包括工作学习需要）的时间？', playTime)}
                {radioInput('socialCharacteristics1', '如何评价社交方面的特点 ', ['追随者', '领导者'])}
                {radioInput('socialCharacteristics2', '', ['难以交上朋友', '容易交上朋友'])}
                {radioInput('socialCharacteristics3', '', ['朋友很多', '朋友很少'])}
                {radioInput('socialCharacteristics4', '', ['交的大多数朋友比我（的孩子）年龄小', '交的大多数朋友比我（的孩子）年龄大'])}
                {radioInput('socialCharacteristics5', '', ['交的朋友有正向影响', '交的朋友有负面影响'])}
            </Box>
            <Box mt={4}>
                <Typography style={{ fontWeight: 500 }}>身心健康</Typography>
                {radioInput('isTakingMedicine', '目前是否在服用药物？', ['没有', '有'])}
                {radioState['isTakingMedicine'] === '1' && radioInput('medicineName', '请选择药品（药名清单及针对的症状）', ['择思达', '专注达', '抗抑郁类', '改善睡眠类', '中成药', '中药汤剂'])}
                <Box mt={2}><Typography color="textSecondary">在成长过程中，是否被医生诊断过以下疾病：</Typography></Box>
                {radioInput('sick1', '1、焦虑症', ['没有', '以前有过', '现在有'])}
                {radioInput('sick2', '2、抑郁症', ['没有', '以前有过', '现在有'])}
                {radioInput('sick3', '3、学习障碍症', ['没有', '有'])}
                {radioInput('sick4', '4、抽动症', ['没有', '以前有过', '现在有'])}
                {radioInput('sick5', '5、高功能自闭症', ['没有', '有'])}
                {radioInput('sick6', '6、ADHD 注意力缺乏多动冲动障碍', ['没有', '有'])}
                <Box mt={2}>
                    <FormControl fullWidth>
                        <FormLabel>7、其他</FormLabel>
                        <TextField value={state['sick7'] ? state['sick7'] : ''} onChange={handleStateChange('sick7')} style={{ width: '200px' }} />
                    </FormControl>
                </Box>
                {radioInput('knowSick', '如果有被诊断为上述1—7的任何一类，本人是否知情', ['是', '否'])}
                {checkBoxInput('behavior', '下面所列举的行为和症状，哪些是目前较多发生的？', behavior)}
            </Box>
            <TextField value={state['supplement2'] ? state['supplement2'] : ''} onChange={handleStateChange('supplement2')} fullWidth multiline rows={5} label="需要补充信息" />
        </Box>
        {/*  */}
        <Box mt={8}>
            <Box>
                <Typography align="center" variant="h6">初步建议及来访者意愿</Typography>
            </Box>
            {!support107(version) && <Box mt={2} color="#FD9438"><Typography color="inherit" variant="subtitle2">{"提示：来访者客户端版本低于1.0.7，选择训练营和关注公众号不将不会显示,1对1教练请务必选择教练和次数"}</Typography></Box>}
            <Box mt={2}>
                <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend">教练建议</FormLabel>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.free_course]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.free_course)} />}
                            label="教练推荐的线上资源和课程"
                        />
                        {!!suggestion[TheInitialInterviewSuggestionType.free_course] && <Box>
                            <Cascader style={{ width: '400px' }} value={suggestion[TheInitialInterviewSuggestionType.free_course]?.cascaderValue || {}} onChange={handleCourseChanged} label="选择课程" size="small" datas={courseCascadeOptions} />
                        </Box>}

                        {!isVip &&
                            <FormControlLabel
                                control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.vip]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.vip)} />}
                                label="推荐线上会员"
                            />
                        }

                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.coach_camp]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.coach_camp)} />}
                            label={"训练营" }
                            placeholder="123"
                        />
                        {!!suggestion[TheInitialInterviewSuggestionType.coach_camp] &&
                            <Box>
                                <TextField select SelectProps={{ multiple: true }} style={{ width: '400px' }} value={suggestionCoachCamp?.coachCampIds ? suggestionCoachCamp.coachCampIds : []} label="选择训练营" size="small" onChange={handleCoachCampChanged} >
                                    {
                                        camps?.map((camp) => <MenuItem key={camp.id} value={`${camp.id}`}>{camp.name}</MenuItem>)
                                    }
                                </TextField>
                            </Box>
                        }
                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.one_on_one_coaching)} />}
                            label="1对1教练"
                        />
                        {!!suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching] &&
                            <Box>
                                <TextField select style={{ width: '140px' }} value={suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]?.type} label="1对1教练类型" size="small" onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.one_on_one_coaching, 'type')} >
                                    {Object.keys(OneOnOneCoachingType).map(k => <MenuItem key={k} value={k}>
                                        {OneOnOneCoachingType[k]}
                                    </MenuItem>)}
                                </TextField>
                                <TextField select style={{ width: '120px', marginLeft: '16px' }} value={suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]?.coachId} label="选择教练" size="small" onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.one_on_one_coaching, 'coachId')} >
                                    <MenuItem key="no_coach" value="0">不指定教练</MenuItem>
                                    {
                                        coaches.map((coach, index) => <MenuItem key={coach.user_id} value={`${coach.user_id}`}>{coach.name}</MenuItem>)
                                    }
                                </TextField>
                                <TextField style={{ width: '120px', marginLeft: '16px' }} label="次数" size="small" value={suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]?.numberOfTimes} onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.one_on_one_coaching, 'numberOfTimes')} />
                                {`${writer.user_id}` === suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]?.coachId && <FormControlLabel style={{ marginLeft: '16px' }} control={<Checkbox
                                    checked={!!suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]?.isDiscount6}
                                    onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.one_on_one_coaching, 'isDiscount6')}
                                />} label="使用教练特惠价" />}
                            </Box>
                        }

                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.group_coaching]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.group_coaching)} />}
                            label="团体教练"
                        />
                        {!!suggestion[TheInitialInterviewSuggestionType.group_coaching] &&
                            <Box>
                                <TextField select style={{ width: '200px' }} value={suggestion[TheInitialInterviewSuggestionType.group_coaching]?.type} label="选择团体教练类型" size="small" onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.group_coaching, 'type')} >
                                    {Object.keys(GroupCoachingType).map(k => <MenuItem key={k} value={k}>
                                        {GroupCoachingType[k]}
                                    </MenuItem>)}
                                </TextField>
                            </Box>
                        }
                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.follow_wxmp]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.follow_wxmp)} />}
                            label="关注公众号"
                        />
                        <FormControlLabel
                            control={<Checkbox size="small" checked={!!suggestion[TheInitialInterviewSuggestionType.recommends_hospital]} onChange={handleSuggestionCheckChange(TheInitialInterviewSuggestionType.recommends_hospital)} />}
                            label="建议到医院寻求诊断和治疗"
                        />
                        {!!suggestion[TheInitialInterviewSuggestionType.recommends_hospital] &&
                            <Box>
                                <TextField style={{ width: '400px' }} rows={3} multiline label="建议" value={suggestion[TheInitialInterviewSuggestionType.recommends_hospital]?.content} onChange={handleSuggestionChange(TheInitialInterviewSuggestionType.recommends_hospital, 'content')} />
                            </Box>
                        }
                    </FormGroup>
                </FormControl>
            </Box>
            <Box mt={2}>
                <TextField fullWidth multiline rows={5} label="其他建议" value={state['other_suggestion'] ? state['other_suggestion'] : ''} onChange={handleStateChange('other_suggestion')} />
            </Box>
            <Box mt={2}>
                <TextField fullWidth multiline rows={5} label="来访者在访谈过程中表达的口头意愿" value={state['clientIntention'] ? state['clientIntention'] : ''} onChange={handleStateChange('clientIntention')} />
            </Box>
        </Box>
    </Box>
}

export default CoachingQuestionnaireSurvey